import { FaTiktok, FaFacebook, FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const socialLinks = [
  { href: 'https://www.tiktok.com/@blueboardesk8', icon: FaTiktok, 'aria-label': 'TikTok' },
  { href: 'https://www.facebook.com/profile.php?id=61570467006347', icon: FaFacebook, 'aria-label': 'Facebook' },
  { href: 'https://www.instagram.com/blueboardtlv/', icon: FaInstagram, 'aria-label': 'Instagram' },
];

const SocialSection = () => {
  const { t, i18n } = useTranslation();
  
  return (
    <section className="bg-gray-800 bg-opacity-80 py-12 rounded-lg" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
      <div className="container mx-auto px-4 text-center">
        <h4 className="text-3xl font-semibold text-white">{t('social.keepInTouch')}</h4>
        <h5 className="text-lg mt-2 mb-4 text-gray-300">
          {t('social.followUs')}
        </h5>
        <div className="mt-6 flex justify-center gap-4">
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link['aria-label']}
              className="bg-white text-blue-600 shadow-lg font-normal h-8 w-8 text-lg md:h-12 md:w-12 md:text-2xl flex items-center justify-center align-center rounded-full outline-none focus:outline-none transform hover:scale-110 transition-transform"
            >
              <link.icon />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialSection; 